<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="Aut"><span href="#/xhtml/contents#c_Aut" title="Link target outside of Sample">A<span class="epub-sc">UTHOR’S</span> N<span class="epub-sc">OTE</span></span></p>
<p class="tni">Cornwall, the southwestern “claw” of England, was for centuries rather astonishingly isolated from the rest of the British Isles. She was not entirely cut off from the world, however. Despite her sometimes inhospitable coasts, shipping reached her. As time passed, there arrived conquerors from Rome, immigrants from Iberia, Celts from France, Mediterranean merchants, Irish voyagers, sailors from Spain. Some came by choice, some were cast up on Cornish beaches by the violence of wind and waves. All brought with them their gods, their spells and incantations, and as Cornwall remained remote and overland travel difficult, the superstitions became ever more a part of the way of life.</p>
<p class="tx">Two miles from Veryan Bay lies the charming village of Veryan, where are five cottages, each circular, and each surmounted by a cross, the idea having been to provide no corners in which Satan might hide. I knew of this, but although I am British born and lived in London until after World War II, I had not realized when I started researching this story just how deeply entrenched were the myths and legends and superstitions of the county. I was, in fact, intrigued to discover that many beliefs and rituals I had assumed to have vanished with the eighteenth century, actually persisted even into the 1940s.</p>
<p class="tx">If, therefore, kind reader, you should feel inclined to raise an eyebrow at some of the episodes in this book, I beg you to believe they are not entirely the products of my imagination.</p>
<p class="tx">I also assure you that I have left out a great deal more than I have included!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authornote.vue?26773070